const Tr = ({ children, onClick, className = "" }) => {
  return (
    <tr
      onClick={onClick}
      className={`shadow-[0_3.5px_5.5px_0_#00000005] h-16 cursor-pointer ${className}`}
    >
      {children}
    </tr>
  );
};

export default Tr;
